/**
 * Get size of Bytes5 (always 5)
 *
 * @param {import('./Bytes5Type.js').Bytes5Type} _bytes - Bytes5
 * @returns {5} Size (always 5)
 *
 * @example
 * ```typescript
 * const size = Bytes5.size(bytes); // 5
 * ```
 */
export function size(_bytes) {
	return 5;
}
